import { PurchaseStatus as PurchaseStatusApi } from '@vendasta/billing';

export enum PurchaseStatus {
  Unset = 'UNSET',
  Pending = 'PENDING',
  Due = 'DUE',
  Success = 'SUCCESS',
  Dunning = 'DUNNING',
  Failed = 'FAILED',
}

export function purchaseStatusFromApi(psApi: PurchaseStatusApi | undefined): PurchaseStatus {
  switch (psApi) {
    case PurchaseStatusApi.PURCHASE_STATUS_PENDING:
      return PurchaseStatus.Pending;
    case PurchaseStatusApi.PURCHASE_STATUS_DUE:
      return PurchaseStatus.Due;
    case PurchaseStatusApi.PURCHASE_STATUS_SUCCESS:
      return PurchaseStatus.Success;
    case PurchaseStatusApi.PURCHASE_STATUS_DUNNING:
      return PurchaseStatus.Dunning;
    case PurchaseStatusApi.PURCHASE_STATUS_FAILED:
      return PurchaseStatus.Failed;
  }
  return PurchaseStatus.Unset;
}
